import { Helmet } from "react-helmet-async";

const SITE = "https://thecrownpathinitiative.org";
const DEFAULT_IMAGE = `${SITE}/images/og-cover.jpg`;

/**
 * Per-page SEO. Sets <title>, meta description, canonical, and OG/Twitter cards.
 * Use on every public, indexable page. Authenticated/dashboard pages get
 * `noindex` automatically.
 */
export default function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} — The Crown Path Initiative` : "The Crown Path Initiative";
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
